import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["select", "form"]
  
  connect() {
    if (this.hasSelectTarget && this.hasFormTarget) {
      this.selectTarget.addEventListener("change", this.submitForm.bind(this))
    }
  }
  
  submitForm() {
    this.formTarget.requestSubmit()
  }
}
